import React from "react";
import { StaticQuery, graphql } from "gatsby";
// import {Link} from 'gatsby';
import MenuItem from "./MenuItem";

/**
 * Define MenuItem fragment and get all primary menu items.
 */
const MENU_QUERY = graphql`
  query GETMAINMENU {
    allWpMenu {
      edges {
        node {
          id
          name
          menuItems {
            nodes {
              id
              label
              target
              title
              url
              parentDatabaseId
              parentId
              childItems {
                nodes {
                  id
                  label
                  target
                  title
                  url
                  parentId
                  parentDatabaseId
                }
              }
            }
          }
        }
      }
    }
    wp {
      generalSettings {
        url
      }
    }
  }
`;

const Menu = () => {
  return (
    <StaticQuery
      query={MENU_QUERY}
      render={(data) => {
        return data.allWpMenu.edges.map((menu) => {
          const wordPressUrl = data.wp.generalSettings.url;
          return (
            <ul className="navbar-nav mr-auto">
              {menu.node.menuItems.nodes.map((menuItem, index) => {
                const parentMenu = menuItem.childItems.nodes.length !== 0;
                return (
                  menuItem.parentDatabaseId === 0 && (
                    <li
                      key={index}
                      className={`nav-item ${parentMenu ? "dropdown" : ""}`}
                    >
                      {/* <div style={{color: "white"}}>
                    {  menuItem.childItems.nodes.length ==0 ? `no child`:`child`}
                  </div> */}
                      <MenuItem
                        menuItem={menuItem}
                        wordPressUrl={wordPressUrl}
                        className={`nav-link ${
                          parentMenu && "dropdown-toggle"
                        }`}
                        data-toggle="dropdown"
                        role="button"
                        aria-expanded="false"
                      />
                      {parentMenu && (
                        <div className="dropdown-menu">
                          {menuItem.childItems.nodes.map((child, index) => {
                            return (
                              <MenuItem
                                key={index}
                                menuItem={child}
                                wordPressUrl={wordPressUrl}
                                className={`dropdown-item`}
                              />
                            );
                          })}
                        </div>
                      )}
                    </li>
                  )
                );
              })}
            </ul>
          );
        });
      }}
    />
  );
};
export default Menu;
